import "./modal-delete.scss";

interface ModalDeleteProps {
  id?: number;
  status: boolean;
  text: string;
  email?: string;
  onClickCancel: (event?: any) => void;
  onClickConfirm: (event?: any) => void;
}

export function ModalMessage({ status, text, onClickCancel, onClickConfirm, id, email }: ModalDeleteProps) {
  return (
    <>
      {status && (
        <div className="bg-overlayModal modalMessageContainer">
          <div className=" shadow-modal modalContent">
            <h1 className="modalContent__title">{text}</h1>

            <div className="modalContent__buttons">
              <button className="btn" type="button" onClick={() => onClickCancel({ status: false, id: 0 })}>
                Não
              </button>
              <button
                className="btn"
                type="button"
                onClick={() => {
                  onClickConfirm(id || email);
                  onClickCancel({ status: false, id: 0 });
                }}
              >
                Sim
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
